import { DateRangePicker } from "@babackapp/ui/components/date-range-picker";
import { Button } from "@babackapp/ui/components/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@babackapp/ui/components/tooltip";
import useTranslation from "@babackapp/translations/use-translation";
import { useAnalyticsFilters } from "../hooks/use-analytics-filters";
import { AnalyticsFilter } from "./analytics-filter";
import { AnalyticsExportButton } from "./analytics-export-button";
import { AnalyticsSettingsDialog } from "./analytics-settings-dialog";
import { X } from "lucide-react";

export function AnalyticsToolbar() {
  const t = useTranslation();
  const { dateRange, setDateRange, clearAll, isAnyFilterApplied } =
    useAnalyticsFilters();

  return (
    <div className="col-span-4 flex items-center justify-end gap-2">
      <AnalyticsFilter />
      {isAnyFilterApplied && (
        <Button
          variant="ghost"
          size="sm"
          className="h-8 px-2 lg:px-3"
          onClick={clearAll}
        >
          {t("misc.filters.clear")}
          <X className="ml-2 h-4 w-4" />
        </Button>
      )}
      <Tooltip>
        <TooltipTrigger asChild>
          <span>
            <DateRangePicker
              className="w-auto"
              range={{
                from: dateRange.from,
                to: dateRange.to,
              }}
              onSelect={(range) => {
                if (range.from && range.to) {
                  setDateRange({ from: range.from, to: range.to });
                }
              }}
              maxDate={new Date()}
            />
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-72 space-y-2 py-3">
          <p className="font-medium">{t("analytics.dateRangeTooltip.title")}</p>
          <ul className="list-disc pl-4 space-y-1 text-xs opacity-80">
            <li>{t("analytics.dateRangeTooltip.orders")}</li>
            <li>{t("analytics.dateRangeTooltip.returns")}</li>
            <li>{t("analytics.dateRangeTooltip.note")}</li>
          </ul>
        </TooltipContent>
      </Tooltip>
      <AnalyticsExportButton />
      <AnalyticsSettingsDialog />
    </div>
  );
}
